import { matchSorter } from 'match-sorter';

export default function filterCustomers(customers, searchText) {
    return customers ? matchSorter(customers, searchText, { keys: ['label'] }) : [];
}
